import React from "react"

export default function TokenDetails({ metadata, image, onDownload }) {
  if (!metadata) return null

  return (
    <div className="card border-0 bg-light rounded-4">
      <div className="card-body p-4">
        <h5 className="card-title mb-3 text-center pixel-font">
          {metadata.name}
        </h5>
        {image ? (
          <>
            <div className="image-wrapper overflow-hidden mb-3 text-center">
              <img
                src={image}
                alt={metadata?.name}
                style={{ maxWidth: "100%", height: "auto", margin: "0 auto" }}
                className="d-block mx-auto"
              />
            </div>
            <div className="d-grid">
              <button
                className="btn btn-primary btn-lg rounded-3"
                onClick={onDownload}
              >
                Download PNG
              </button>
            </div>
          </>
        ) : (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
